import {StyleSheet, Font} from "@react-pdf/renderer";


const oSans =  require('../../media/PDFReport/fonts/OpenSans-Regular.ttf')
const oSansBold =  require('../../media/PDFReport/fonts/OpenSans-Bold.ttf')
Font.register({src: `${window.location.origin}/${oSans}`, family:'Open Sans'})
Font.register({src: `${window.location.origin}/${oSansBold}`, family:'Open Sans Bold'})


// Create styles
export const PipePDFReportStyles = StyleSheet.create({
  viewer: {
    top: 30,
    left: 0,
    width: '100%',
    height: '100%',
    position: 'absolute'
  },
  document: {},
  page: {backgroundColor: 'white'},
  headerView: {
    margin: 10,
    padding: 10,
    //backgroundColor: '#E4E4E4',
  },
  titleFrameView: {
    padding: 10,
    marginLeft: 10,
    marginRight: 10,
    //backgroundColor: '#E4E4E4',
  },
  primaryFrameView: {
    padding: 10,
    marginTop: 10,
    marginLeft: 10,
    marginRight: 10,
    //backgroundColor: '#E4E4E4',
  },
  contentView: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
    backgroundColor: 'white'
  },
  tableView: {
    padding: 10,
    marginLeft: 0,
    borderWidth: 1,
    marginRight: 10,
    border: 'solid',
    borderColor: '#E4E4E4',
    backgroundColor: '#e3f2fd',
  },
  primaryText: {
    fontSize: 20
  },
  secondaryText: {
    fontSize: 16,
    color: '#106EBE',
  },
  tableText: {
    fontSize: 9,
    marginTop: 3,
    color: 'black',
    fontFamily:'Open Sans'
  },
  tableText2: {
    fontSize: 9,
    marginTop: 3,
    color: 'grey',
    fontFamily:'Open Sans'
  },
  tableTextBold: {
    fontSize: 9,
    marginTop: 3,
    color: 'black',
    fontFamily:'Open Sans Bold'
  },
  tableTextBold2: {
    fontSize: 9,
    marginTop: 3,
    color: 'grey',
    fontFamily:'Open Sans Bold'
  },
  tableTextValue: {
    fontSize: 10,
    color: 'black',
  },
  imgStyle: {
    // width:300,
    // height: 300
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  logoImgStyle: {
    width: 110,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  sectionImgStyle: {
    width: 550,
    marginTop:'60px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  titleText: {
    fontSize: 13,
    color: 'black',
    marginTop: '10px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '10px',
    fontFamily:'Open Sans',
    textDecoration: 'underline',
  },
  rowView: {
    debug: true,
    display: 'flex',
    flexDirection: 'row'
  },
  colView: {
    debug: true,
    width: '49%',
    paddingLeft: 30,
    display: 'flex',
    alignSelf: 'stretch',
  },
  innerLColView: {
    debug: true,
    width: '65%',
    display: 'flex',
    alignSelf: 'stretch',
  },
  innerRColView: {
    debug: true,
    width: '34%',
    display: 'flex',
    alignSelf: 'stretch',
  },
  contentRowView: {
    debug: true,
    width: '100%',
    fontSize: 10,
    display: 'flex',
    paddingLeft: 30,
    paddingRight: 30,
    textAlign: 'justify',
    alignSelf: 'stretch',
  },
  boldLetters: {
    fontSize: 10,
    color: 'black',
    fontFamily:'Open Sans Bold'
  },
  links: {
    textDecoration: 'none',
    color: '#3399ff',
  }
});



// WEBPACK FOOTER //
// ./src/components/PipesPDF/pdfreport.stylesheet.js